import React from 'react';
import Pagination from 'rc-pagination';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';

const PaginationComponent = ({
  currentPage,
  totalItems,
  pageSize,
  handlePageChange,
}) => {
  const totalPages = Math.ceil(totalItems / pageSize);

  const isPrevDisabled = currentPage === 1;
  const isNextDisabled = currentPage === totalPages;

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          padding: '10px',
        }}
      >
        {/* Prev Button */}
        <div>
          <Pagination
            current={currentPage}
            total={totalItems}
            pageSize={pageSize}
            onChange={handlePageChange}
            showTitle={false}
            prevIcon={
              <div
                className={`flex items-center gap-1 text-lg font-normal cursor-pointer ${
                  isPrevDisabled ? 'text-gray-500' : 'text-light__grey'
                }`}
                style={{ pointerEvents: isPrevDisabled ? 'none' : 'auto' }}
              >
                <div className="flex items-center justify-center">
                  <FiArrowLeft size={18} />
                </div>
                <p>Prev</p>
              </div>
            }
            nextIcon={null} // Hide "Next" here
            itemRender={(page, type, element) => {
              if (type === 'prev') {
                return element;
              }
              return null;
            }}
          />
        </div>

        {/* Page Numbers */}
        <div>
          <Pagination
            current={currentPage}
            total={totalItems}
            pageSize={pageSize}
            onChange={handlePageChange}
            showTitle={false}
            hideOnSinglePage={false}
            showPrevNextJumpers
            prevIcon={null}
            nextIcon={null}
            className="flex items-center justify-center gap-2"
            itemRender={(page, type, element) => {
              if (type === 'page') {
                return (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '2.5rem',
                      height: '2.5rem',
                      borderRadius: '0.3125rem',
                      cursor: 'pointer',
                      backgroundColor:
                        currentPage === page ? 'white' : 'transparent',
                      color: currentPage === page ? '#000000' : '#B0B0B0',
                      border: '1px solid #B0B0B0',
                    }}
                  >
                    {page}
                  </div>
                );
              }

              if (type === 'jump-prev' || type === 'jump-next') {
                return (
                  <div style={{ padding: '0 8px', color: '#ffffff' }}>
                    <span>...</span>
                  </div>
                );
              }

              return null;
            }}
          />
        </div>

        {/* Next Button */}
        <div>
          <Pagination
            current={currentPage}
            total={totalItems}
            pageSize={pageSize}
            onChange={handlePageChange}
            showTitle={false}
            prevIcon={null}
            nextIcon={
              <div
                className={`w-[80px] flex flex-row items-end justify-between gap-1 text-lg font-normal cursor-pointer ${
                  isNextDisabled ? 'text-gray-500' : 'text-light__grey'
                }`}
                style={{
                  pointerEvents: isNextDisabled ? 'none' : 'auto',
                  // border: '1px solid red',
                }}
              >
                <div className="flex items-center justify-center">
                  <div
                    // style={{ border: '1px solid red' }}
                    className="p-0 h-[20px] flex items-center justify-center"
                  >
                    Next
                  </div>
                  <div
                    className="flex items-center justify-center h-[20px]"
                    // style={{ border: '1px solid red' }}
                  >
                    <FiArrowRight size={18} />
                  </div>
                </div>
              </div>
            }
            itemRender={(page, type, element) => {
              if (type === 'next') {
                return element;
              }
              return null;
            }}
          />
        </div>
      </div>
    </>
  );
};

export default PaginationComponent;
